export default "__VITE_ASSET__CXpy8eY2__"